<template>
  <div class="loading">
    <img class="load" src="static/images/load.gif" />
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
}
</script>
<style scoped>
.loading{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, .7);
  z-index: 99999999;
}
</style>



// WEBPACK FOOTER //
// src/components/common/loading.vue